export const reOrderGeoReferenceIndex = (values: any) => {
  return {
    ...values,
    georeferences: values.georeferences?.map((georeference: any, index: number) => ({
      ...georeference,
      origin: { ...georeference.origin, order: index + 1 },
    })),
  };
};
